import { useEffect } from 'react';

/**
 * Révèle les cartes .scope-card-landing / .pieges-card au défilement (flip 3D, ds-fx.css).
 * ds-fx.css les rend invisibles (opacity 0) tant qu'elles n'ont pas la classe `reveal-in` : toute page
 * qui en affiche DOIT appeler ce hook, sinon elles restent cachées (bug du 20/10/2026 sur les pages
 * d'aide DGFiP et ATSEM, où seule la page Fonctionnalités le faisait).
 * deps : à repasser quand les cartes sont rendues après un chargement (ex. liste des thématiques).
 */
export default function useRevealCards(deps = []) {
    useEffect(() => {
        const els = document.querySelectorAll('.scope-card-landing, .pieges-card');
        if (!els.length) return undefined;
        if (!('IntersectionObserver' in window)) {
            els.forEach((el) => el.classList.add('reveal-in'));
            return undefined;
        }
        // Desktop : on déclenche plus tard (carte bien visible) ; mobile : tôt (viewport court).
        const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
        const io = new IntersectionObserver((entries) => {
            // Cascade : les cartes qui entrent ensemble s'enchaînent dans l'ordre visuel (haut→bas, gauche→droite).
            const fresh = entries.filter((e) => e.isIntersecting).map((e) => e.target);
            fresh.sort((a, b) => {
                const ra = a.getBoundingClientRect();
                const rb = b.getBoundingClientRect();
                return (ra.top - rb.top) || (ra.left - rb.left);
            });
            fresh.forEach((el, k) => {
                const delay = `${k * 0.18}s`;
                el.style.transitionDelay = delay;
                el.style.animationDelay = delay;
                el.classList.add('reveal-in');
                io.unobserve(el);
            });
        }, isDesktop ? { threshold: 0.4, rootMargin: '0px 0px -8% 0px' } : { threshold: 0.15 });
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
